import { useContext } from "react";
import {
  LoaderContextA,
  LoaderContextAType,
} from "../miscellaneous/LoaderContextA";

export function useLoaderContextA<T>() {
  return useContext(LoaderContextA) as LoaderContextAType<T> | null;
}
